import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import { ExcelWorkSheet } from './worksheet';

export async function generateExcelWorkBook(
  fileName: string,
  worksheets: ExcelWorkSheet[]
): Promise<void> {
  if (worksheets && worksheets.length) {
    const workbook = new Workbook();
    worksheets.forEach((ws) => {
      const ejsWorksheet = workbook.addWorksheet(ws.name);
      ws.applyToWorksheet(ejsWorksheet);
    });
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    saveAs(blob, `${fileName}.xlsx`);
  }
}

